import Vue from 'vue';
import { mapGetters } from 'vuex';
import Notification from './notification';

export default Vue.component('notifications-container', {
  template: require('./template.html'),
  components: {
    Notification,
  },
  computed: {
    ...mapGetters([
      'notifications',
    ]),
  },
  name: 'notifications-container',
});



// WEBPACK FOOTER //
// ./src/global-view/notifications/index.js